import styled from "styled-components";

import { Typo } from "@enkor/design/components";
import { getOpacityColor, grayScale } from "@enkor/design/colors";

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;

  width: 100%;
  height: 100%;
  padding: 64px 24px 80px;

  background: ${getOpacityColor(grayScale[200], 0.7)};
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
`;

export const Phrase = styled(Typo.Heading)`
  line-height: 26px;
  text-align: center;
  white-space: pre-line;
`;
